export const ButtonVariants = {
    variants: {
        primary: {
            bgColor: 'primary.600',
            color: 'neutral.50'
        },
        secondary: {
            bgColor: 'neutral.50',
            color: 'primary.600'
        },
        iconPrimary: {
            bgColor: 'neutral.50',
            color: 'neutral.600'
        },
        feedback: {
            bgColor: 'primary.700',
            color: 'neutral.50',
            fontSize: '12px',
            width: '100px',
            margin: '0 5px',
            borderRadius: '20px'
        },
        needHelp: {
            bgColor: 'secondary.500',
            color: 'neutral.50',
            fontSize: '12px',
            width: '100px',
            margin: '0 5px'
        },
        outline: {
            color: 'primary.700',
            borderRadius: '20px',
            borderColor: 'primary.500',
            paddingInlineStart: 'var(--chakra-space-3)',
            paddingInlineEnd: 'var(--chakra-space-4)',
            svg: { path: { fill: 'primary.700' } }
        }
    }
};
